'use client'

import { SiteShell } from '@/components/site/site-shell'
import { PageIntro } from '@/components/site/page-intro'
import { MagneticLink } from '@/components/site/magnetic-button'

export default function BlogIndexPage() {
  return (
    <SiteShell>
      <div className="mx-auto w-full max-w-3xl px-6 pb-20 pt-24 md:pb-32 lg:px-12">
        <PageIntro
          eyebrow="Blog"
          title={
            <>
              Web design &amp;
              <br />
              <span className="italic text-muted-foreground">product insights</span>
            </>
          }
          description="Articles on our process, client work, and how we build for production."
        />
        <p className="mb-10 text-muted-foreground leading-relaxed">
          We are preparing our first posts. Check back soon, or reach out if you have a topic you would
          like us to cover.
        </p>
        <MagneticLink href="/contact" variant="outline">
          Get in touch
        </MagneticLink>
      </div>
    </SiteShell>
  )
}
